<div class="row justify-content-center tabla">
    <div class="col-md-8 tab">
        <ul class="nav nav-tabs justify-content-center">
            <li class="nav-item active">
                <a class="nav-link active" data-toggle="tab" href="#errores">Tabla de Errores</a>
            </li>
        </ul>
        <div class="tab-pane" id="errores">
            <div class="col-md-12">
                <br>
                <div style="width: auto; height: auto;">
                    <table class="table table-danger table-hover">
                        <thead>
                            <tr>
                                <td>TIPO</td>
                                <td>ERROR</td>
                                <td>FILA</td>
                                <td>COLUMNA</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>
            </div>
        </div>
    </div>
</div>